import React from "react"

function NoResults() {
	return <div className="noResults font">No Search Results</div>
}

export default NoResults
